import { isAfter } from 'date-fns';
import { type Authentication, ExternalProvider } from 'vince-core/types/auth';
import { EXTERNAL_PROVIDERS } from 'vince-core/constants/externalProviders';

export const useExternalProvidersAuthStore = defineStore('externalProvidersAuthStore', () => {
    const activeAuthentications = ref<Authentication[]>([]);
    const initializedProviders = [] as ExternalProvider[];

    function getAuthentication (provider: ExternalProvider): Authentication | undefined {
        const now = new Date();
        return activeAuthentications.value.find(it => it.provider === provider && (!it.expireOn || isAfter(it.expireOn, now)));
    }

    function addAuthentication (a: Authentication) {
        activeAuthentications.value = [...activeAuthentications.value.filter(auth => auth.provider !== a.provider), a];
    }

    async function authenticate (provider: ExternalProvider) {
        if (getAuthentication(provider) !== undefined) { return; }

        if (!initializedProviders.includes(provider)) {
            await EXTERNAL_PROVIDERS[provider]!.initialize();
            initializedProviders.push(provider);
        }
        addAuthentication(await EXTERNAL_PROVIDERS[provider]!.authenticate());
    }

    return { authenticate, getAuthentication };
});
